import React, {useState} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_TEXT, ATTR_OBJ_ID, ATTR_ENUM_VALUES, getValidAttr, UI_LISTED_ELEMENTS_LIMIT, ATTR_MAIN_PROJ_ID
} from "../prodect/ProsConnect";
import BasicButton, {ConfirmButton} from "../components/BasicButton";
import LoadingAnimation from "../components/LoadingAnimation";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import prosAppNotif, {prosAppNotifWarn} from "../prodect/ProsAppNotif";
import EnumListEdit from "./EnumListEdit";

export function CustomerEnums({ customerId, mainProjId }) {

    const [refreshConfigs, setRefreshConfigs] = useState(false)
    const [enumConfigs, setEnumConfigs] = useState([])
    const [loadingNote, setLoadingNote] = useState('')

    const getCustomerEnums = React.useCallback(async () => {
        setLoadingNote("Hetkinen - ladataan valintalistat..")
        const configs = await prosConnect.getAllEnums(customerId)
        if(Array.isArray(configs)) {
            setEnumConfigs(configs)
        }
        setLoadingNote("");
      }, [customerId]);

    React.useEffect(() => {
        getCustomerEnums()
        return () => {
            BasicModalDismiss()
        }
    }, [getCustomerEnums, refreshConfigs])

    function renderBriefEnumList(enums) {
        const showMax = UI_LISTED_ELEMENTS_LIMIT / 2
        let count = enums ? enums.length : 0
        let valuesString = "[" + count + "] " + (enums ? enums.slice(0,showMax).join(";") : "")
        if (count > showMax) valuesString += "..."
        return valuesString
    }

    function renderEnumList() {
        let enumConfigsFiltered = enumConfigs
        if (mainProjId) {
            enumConfigsFiltered = enumConfigs.filter(config => ! config.hasOwnProperty(ATTR_MAIN_PROJ_ID) || config[ATTR_MAIN_PROJ_ID] === mainProjId)
        }
        if (!enumConfigsFiltered || enumConfigsFiltered.length === 0) {
            if (mainProjId) {
                return <p>Projektille ei ole valintalistoja.</p>
            }
            return <p>Asiakkaalle ei ole valintalistoja.</p>
        }
        //Is this needed?
        //<p>{formatDate(enumList[ATTR_UPDATED_MS_I], true)}, {enumList[ATTR_UPDATED_BY]}</p>
        return <div className="slab grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd">
            {enumConfigsFiltered.map(enumList => {
                return <div key={enumList[ATTR_OBJ_ID]}
                            className={"inpage-box"}
                >
                    <h3>{enumList[ATTR_OBJ_ID]}</h3>
                    {getValidAttr(enumList, ATTR_TEXT, null) ? <p>{enumList[ATTR_TEXT]}</p> : null}
                    <p className={"flex-grow"}>{renderBriefEnumList(enumList[ATTR_ENUM_VALUES])}</p>
                    <div className={"btn-set_right"}>
                        <BasicButton
                            btnClass={"2nd"}
                            icon={"edit"}
                            action={() => {
                                openEditEnumItemModal(enumList)
                            }}
                            btnType={"prompt"}
                        />
                        <ConfirmButton
                            btnClass={"2nd"}
                            action={() => {
                                confirmedDelete(enumList)
                            }}
                            confirmAction
                            hideLabel
                            btnType={"fatal"}
                        />
                    </div>
                </div>
            })}
        </div>
    }

    const confirmedDelete = async (objToBeDeleted) => {
        prosAppNotif("Valintalistan poistaminen ei ole vielä mahdollista")
    }

    const openEditEnumItemModal = (enumList) => {
        BasicModal("Tallenna valintalista",
            <EnumListEdit
                closeCallback={BasicModalDismiss}
                setOptionsCallback={configs => saveEnumList(configs)}
                prevConfig={enumList}
                reservedIds={enumConfigs.map(el => el[ATTR_OBJ_ID])}
                mainProjId={mainProjId}
            />, {
            hideDismissButton: true
        })
    }

    const saveEnumList = async (changes) => {
        let wasSaved = await prosConnect.saveEnum(customerId, changes)
        if (!wasSaved) {
            prosAppNotifWarn("Enum listan tallennus ei onnistunut")
        }
        setRefreshConfigs(!refreshConfigs)
        BasicModalDismiss()
    }

    return <>
        <h2>Valintalistat</h2>
        {loadingNote && <LoadingAnimation size={"lg"} text={loadingNote}/>}
        {renderEnumList()}
        <BasicButton
            btnClass={"primary"}
            label={"Luo valintalista"}
            icon={"plus"}
            disabled={false}
            action={()=>{
                openEditEnumItemModal()
            }}
        />
    </>
}
